<!--
 * @Author: likk
 * @Date: 2023-09-04 18:09:43
 * @LastEditTime: 2024-03-22 03:15:33
 * @LastEditors: likk 1126919170@qq.com
 * @Description: 作业服务发布
-->
<template>
  <el-main class="business-area">
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="top-tit">
        作业服务修改
      </div>
      <el-form ref="form" :model="form" :inline="true" :rules="rules" :hide-required-asterisk="true" label-width="100px">
        <el-form-item prop="ownerName" label="服务方名称">
          <el-input v-model="form.ownerName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="contactPhone" label="联系电话">
          <el-input v-model="form.contactPhone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="checkedWorkArea" label="作业地区">
          <el-cascader :options="regionData" :props="props" v-model="form.checkedWorkArea"
            popper-class="region-wrap" collapse-tags  clearable placeholder="请选择作业地区"></el-cascader>
        </el-form-item>
        <el-form-item prop="checkedWorkType" label="作业类型">
          <el-cascader
            :options="workTypeTree"
            :props="workTypeProps"
            v-model="form.checkedWorkType"
            popper-class="issue-worktype-wrap"
            collapse-tags
            clearable
            placeholder="请选择作业类型"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="serviceThumb" label="服务照片" class="w100">
          <p class="tip-txt">上传的照片为农机/机手照片，方便农户找您作业</p>
          <el-upload
            :action="'#'"
            accept="image/jpeg,image/gif,image/png"
            :multiple="false"
            :show-file-list="false"
            list-type="picture-card"
            :data="{ xtype: 'ysb_product', type: 'image' }"
            :on-success="handleImgSuccess"
            :http-request="handleCustomUpload"
          >
            <img class="thumb" v-if="form.serviceThumb" :src="form.serviceThumb"/>
            <template v-else>
              <i class="el-icon-plus"></i>
              <span>服务照片</span>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item prop="checkedRegion" label="所在位置" class="w100">
          <el-cascader :options="regionData" :props="props1" v-model="form.checkedRegion" placeholder="请选择所在位置" @change="checkedRegionChange"></el-cascader>
        </el-form-item>
        <el-form-item prop="workAddress" label=" " class="w100">
          <p class="address">{{form.workAddress}}<span class="btn-text">点击地图获取位置</span></p>
          <div class="map-box" id="mapDiv"></div>
        </el-form-item>
        <el-form-item label=" " prop="machineRefList" class="w100">
          <el-button type="primary" @click="handleEditMachine()">添加农机</el-button>
          <el-table :data="form.machineRefList" v-if="form.machineRefList.length>0">
            <el-table-column prop="machineName" label="农机品目" align="center" min-width="12%"></el-table-column>
            <el-table-column prop="brandName" label="品牌" align="center" min-width="12%"></el-table-column>
            <el-table-column prop="modelName" label="型号" align="center" min-width="12%"></el-table-column>
            <el-table-column prop="buyDate" label="购机日期" align="center" min-width="12%"></el-table-column>
            <el-table-column prop="factoryCode" label="出厂编号" align="center" min-width="12%"></el-table-column>
            <el-table-column label="照片" align="center" min-width="12%">
              <template slot-scope="{row}">
                <img class="thumb-machine" :src="row.machinePhotos" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="12%">
              <template slot-scope="scope">
                <el-button type="text" @click="handleEditMachine(scope.row,scope.$index)">编辑</el-button>
                <el-button type="text" @click="handleDelMachine(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div class="foot">
        <el-button type="primary" class="btn-gray" @click="handleReset()">重置</el-button>
        <el-button type="primary" @click="handleIssue()" :loading="loading">修改</el-button>
      </div>
      <EditMachine v-if="dialogVisible" :machineInfo="machineInfo" @submit="handleAddMachine" @close="handleDialogClose"></EditMachine>
    </div>
  </el-main>
    
</template>

<script>
  import EditMachine from './components/EditMachine';
  import TalksMap from "@/utils/initMapTalks.js";
  import { uploadImg } from "@/api/uploadImg";
  import * as maptalks from "maptalks";
  import regionSeatLibs from 'utils/regionSeatLibs'
  let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
  import { workTypeTree,workServiceModify, geocoder, workServiceDetail, getlatLngByRegionId} from "@/api/gxInfo";
  export default {
    data(){
      var checkePhone = (rule, value, callback) => {
        var reg = /^1\d{10}$/;
        if (!value) {
          callback(new Error('请输入联系电话'));
        }else if(!reg.test(value)){
          callback(new Error('联系电话格式不正确'));
        }else{
          callback()
        }
      }
      return {
        id: "",
        TalksMapDialog: new TalksMap(),
        form:{
          identityType:10,
          ownerName: "",
          contactPhone: "",
          checkedWorkType: [],
          checkedWorkArea:[],//作业地区
          checkedRegion:[],//所在位置-省市县
          workAddress:"",
          lng:'',
          lat:'',
          machineRefList:[],//农机列表
          serviceThumb: "",
        },
        rules:{
          ownerName: {required: true, message: '请输入服务方名称', trigger: 'blur'},
          contactPhone:{validator: checkePhone, trigger: 'blur'},
          checkedWorkArea:{required: true, message: '请选择作业地区', trigger: 'change'},
          checkedWorkType:{required: true, message: '请选择作业类型', trigger: 'change'},
          checkedRegion:{required: true, message: '请选择作业位置', trigger: 'change'},
          workAddress:{required: true, message: '请标注详细位置', trigger: 'change'},
          machineRefList:{required: true, message: '请添加农机', trigger: 'change'},
          serviceThumb: {required: true, message: '请上传服务照片', trigger: 'change'}
        },
        
        dialogVisible:false,
        machineInfo:{},
        regionData,
        // addressList:[],
        props: {
          multiple: true,
          value: 'i',
          label: 'n',
          children: 'c'
        },
        props1: {
          value: 'i',
          label: 'n',
          children: 'c'
        },
        workTypeTree:[],//作业类型数据
        workTypeProps:{
          multiple: true,
          value: 'code',
          label: 'name',
          children: 'children'
        },
        loading:false
        
      }
    },
    components:{
      EditMachine
    },
    // computed:{
    //   user()  {
		// 		return this.$store.state.user
		// 	},
    // },
    // watch: {
    //   ["form.checkedRegion"]: {
    //     handler(val) {
    //       this.getRegionLngLat(val[val.length-1]);
    //     }
    //   }
    // },
    created(){
      this.id = this.$route.query.id;
      this.getWorkTypes();
    },
    mounted(){
      this.mapInit();
      this.getDetail();
    },
    methods:{
      checkedRegionChange(val) {
        this.getRegionLngLat(val[val.length-1]);
      },
      async getDetail(){
        const { data: { result } } = await workServiceDetail(this.id);
        for(let key in this.form){
          if(key== "ownerName"){
            this.form.ownerName = result.ownerPlainName;
          }else if( key == "contactPhone"){
            this.form.contactPhone = result.contactPlainPhone;
          }else if( key == "checkedWorkType") {
            const workTypes = result.workTypes.split(",");
            const arr = [];
            this.workTypeTree.forEach(item => {
              item.children.forEach(itm => {
                if(workTypes.includes(itm.code)){
                  arr.push([item.code,itm.code])
                }
              })
            });
            this.form.checkedWorkType = arr;
          }else if( key == "checkedWorkArea" ) {
            this.form.checkedWorkArea = result.workAreaList.map(item => ([
              item.provinceId,item.cityId,item.countyId
            ]))
          } else if( key =="checkedRegion"){
            this.form.checkedRegion = [result.workProvinceId,result.workCityId,result.workCountyId];
          }else{
            result[key] && (this.form[key] = result[key]);
          }
        }
        this.TalksMapDialog.map.setCenter({ x:result.lng, y:result.lat})
        this.markerOnClick(result.lng, result.lat);
      },
      /**
       * @description: 根据地区ip获取地图中心点经纬度
       * @return {*}
      */  
      async getRegionLngLat(regionId) {
        if(regionId){
          const { data: {result}} = await getlatLngByRegionId({ regionId });
          this.TalksMapDialog.map.setCenter({ x:result.lng, y:result.lat})
        }
      },  
      /**
       * @Author: likk
       * @description: 获取作业类型
       * @param {*}
       * @return {*}
       */ 
      async getWorkTypes(){
        const { data: {result} } = await workTypeTree() || [];
        this.workTypeTree = result;
      },     
      /**
       * @Author: likk
       * @description: 添加/编辑农机
       * @param {Object} row 编辑操作时携带的数据
       * @param {Number} index 当前编辑数据的下标
       * @return {*}
       */ 
      handleEditMachine(row={},index){
        this.machineInfo = row;
        (index || index===0) && (this.machineInfo.index = index);
        this.dialogVisible = true;
      }, 
      /**
       * @Author: likk
       * @description: 删除农机
       * @param {*}
       * @return {*}
       */
        
      handleDelMachine(index){
        this.form.machineRefList.splice(index,1);
      },

      /**
       * @Author: likk
       * @description: 地图初始化
       * @param {*}
       * @return {*}
       */  
       mapInit(){
        this.TalksMapDialog.sendThis(this);
        let center = [116.3, 39.9];
        this.TalksMapDialog.init("mapDiv", 17, center);
        this.pic1Marker = new maptalks.VectorLayer("pic1Marker").addTo(
          this.TalksMapDialog.map
        );
        // 监听地图点击事件
        this.TalksMapDialog.map.on("click", (param) => {
          let lng = Number(param.coordinate.x),lat = Number(param.coordinate.y);
          this.form.lng = lng;
          this.form.lat = lat;
          this.markerOnClick(lng,lat);
          this.getAddressByLngLat(lat,lng,(res) => {
            this.form.workAddress = res.address
          })
        });
      },
      /**
       * @Author: likk
       * @description: 地图标记点点击事件
       * @param {*}
       * @return {*}
       */    
      markerOnClick(lng,lat){
        this.pic1Marker && this.pic1Marker.clear();
        //向地图上添加自定义标注
        new maptalks.Marker(
          [lng,lat],
          {
            symbol: [
              {
                markerFile: require("@/assets/gx/biaozhu_dingwei.png"),
                markerWidth: 22,
                markerHeight: 32,
                markerOpacity: 1,
              },
            ],
          }
        ).addTo(this.pic1Marker);
      },  
      /**
       * @Author: likk
       * @description: 根据经纬度获取详细地址
       * @param {*}
       * @return {*}
       */   
      async getAddressByLngLat(lat,lng,fn) {
        let coords = lat + "," +lng
        let {data:{result}}  = await geocoder({coords:coords});
        fn(result);
      },
      /**
       * @Author: likk
       * @description: 添加农机成功
       * @param {*}
       * @return {*}
       */      
      handleAddMachine(row){
        this.handleDialogClose();
        if(row.index || row.index===0){//编辑
          this.$set(this.form.machineRefList,row.index,row)
        }else{//新增
          this.form.machineRefList.push(row);
        }
      },
    /**
     * @Author: likk
     * @description: 添加/修改机具弹框关闭事件
     * @param {*}
     * @return {*}
     */ 
     handleDialogClose(){
      this.dialogVisible = false;
     }, 
     /**
        @Author: likk
      * @description: 自定义上传
      * @param {*}
      * @return {*}
      */ 
      handleCustomUpload(content) {
        uploadImg(content).then((res) => {
            content.onSuccess(res.data);
          }).catch((err) => {
            content.onError(err);
            this.$message.error("服务器异常，请重新上传");
          });
      },
      /**
       * @Author: likk
       * @description: 上传成功
       * @param {*}
       * @return {*}
      */
      handleImgSuccess(file){
        this.form.serviceThumb = file.url;
        this.$refs.form.clearValidate('serviceThumb');
      },
      /**
     * @Author: likk
     * @description: 发布
     * @param {*}
     * @return {*}
     */  
    handleIssue(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading=true;
          let { checkedWorkType,checkedWorkArea,checkedRegion,...params } = this.form;
          let workTypes = checkedWorkType.map( item => item[1]).join(',');
          let workAreaList = checkedWorkArea.map( item => {
            return {
              provinceId:item[0],
              cityId:item[1],
              countyId:item[2]
            }
          })
          // if(this.userLevel$$ == 2){//省账号
          //   checkedRegion = [this.user.provinceId].concat(checkedRegion)
          // }else if(this.userLevel$$ == 3){//市账号
          //   checkedRegion= [this.user.provinceId,this.user.cityId].concat(checkedRegion)
          // }
          workServiceModify({
            id:this.id,
            ...params,
            workProvinceId:checkedRegion[0],
            workCityId:checkedRegion[1],
            workCountyId:checkedRegion[2],
            workTypes,
            workAreaList,
          }).then(() => {
            this.loading=false;
            this.$message.success("修改成功");
            this.$router.push({ path:'/gx-query/service/list' })
          }).catch(() => {
            this.loading=false;
          })
        }
      })
      
    },
      /**
      * @Author: likk
      * @description: 重置
      * @param {*}
      * @return {*}
      */  
      handleReset(){
        this.$refs.form.resetFields();
        this.pic1Marker && this.pic1Marker.clear();
      }  
    },
  }
    
</script>

<style lang="scss" scoped>
  @import "../style.scss";
  .main{
    padding: 0 !important;
    .top-tit{
      height: 56px;
      line-height: 56px;
      font-size: 20px;
      color: #018388;
      font-weight: bold;
      padding: 0 20px;
      border-bottom: 1px solid #EFEFEF;
    }
    ::v-deep .el-form{
      padding: 20px;
      .el-form-item{
        width: 45%;
        .el-input{
          width: 300px;
        }
        .address{
          font-size: 16px;
          color: #333333;
          .btn-text{
            color: #018388;
            text-decoration: underline;
            margin-left: 4px;
          }
        }
        &.w100{
          width: 100%;
          .map-box{
            width: 54.5vw;
            height: 400px;
          }
          .el-table{
            width: 54.5vw;
            max-height: 400px;
          }
          .tip-txt{
            font-size: 14px;
            color: #9A9A9A;
            line-height: 40px;
          }
        }
      }
    }
    .foot{
      text-align: center;
      .el-button{
        font-size: 18px;
        padding: 14px 41px;
        margin: 0 10px;
        &.btn-gray{
          background: #DFDFDF;
          border-color: #DFDFDF;
        }
      }
    }
    .thumb-machine{
      width: auto;
      height: 40px;
    }
  }
  
</style>
<style lang="scss">
  //用样式去除作业类型级联一级菜单前的勾选框
  .issue-worktype-wrap{
    .el-cascader-panel{
      .el-cascader-menu{
        &:nth-child(1){
          .el-checkbox{
            display: none !important;
          }
        }
      }
    }
  }
</style>